import React from 'react'
import MarkdownRenderer from 'react-markdown-renderer'

import { tx } from '@twind/core'
import { MarkdownRendererOptions } from 'config/remarkable'

import 'prismjs/themes/prism-okaidia.min.css'

const CustomMarkdownRenderer = ({
  details,
  wrapperClassName,
  options
}: {
  details: string
  wrapperClassName?: string
  options?: Partial<typeof MarkdownRendererOptions>
}) => {
  return (
    <div
      className={tx('prose break-words', wrapperClassName)}
      style={{ maxWidth: '100%' }}>
      <MarkdownRenderer
        markdown={details || ''}
        options={{ ...MarkdownRendererOptions, ...options }}
      />
    </div>
  )
}

export default CustomMarkdownRenderer
